import { useMutation, useQuery } from "@tanstack/react-query";
import { ambulatoryVisitApiService } from "modules/Clinical/AmbulatoryVisit/api/ambulatoryVisit.api";
import { GetUserData } from "common/service/CommonService";

interface IAmbulatoryVisitService {
    studyid?:number,
    searchtext?:string,
    currentPage?:number,
    pageSize?:number,
    visitid?:number,
    subjectassignmentid?:number,
}

export const useAmbulatoryVisitService = ({studyid,searchtext,currentPage,pageSize,visitid,subjectassignmentid}:IAmbulatoryVisitService) => {

    const SelectAllAmbulatoryVisit = useQuery({
        queryKey: ["selectall-ambulatory-visit",studyid,searchtext,currentPage,pageSize],
        queryFn: () =>
            ambulatoryVisitApiService.selectallAmbulatoryVisit({
                studyid:studyid,
                searchtext:searchtext,
                currentpage:currentPage,
                pagesize:pageSize,
            }),
        enabled:!!studyid,
    });

    const SelectdataAmbulatoryVisit = useQuery({
        queryKey: ["selectdata-ambulatory-visit", studyid, visitid],
        queryFn: () =>
            ambulatoryVisitApiService.selectdataAmbulatoryVisit({studyid,visitid}),
        enabled:!!studyid && !!visitid,
    });

    const assignSubjectsAmbulatoryVisit = useMutation({
        mutationFn: (payload: any) =>
            ambulatoryVisitApiService.assignSubjects(payload),
    });

    const insertAmbulatoryVisitStatusHistory = useMutation({
        mutationFn: (payload: any) =>
            ambulatoryVisitApiService.insertAmbulatoryVisitStatusHistory(payload),
    });

    const SelectAllAssignedSubjects = useQuery({
        queryKey: ["selectall-assigned-subjects", studyid, visitid, searchtext, currentPage, pageSize],
        queryFn: () => {
            return ambulatoryVisitApiService.selectAllAssignedSubjects({
                visitid: Number(visitid),
                searchtext: searchtext,
                currentpage: currentPage,
                pagesize: pageSize 
            });
        },
        enabled: !!visitid,
    });

    const checkInSubject = useMutation({
        mutationFn: (payload: any) =>
            ambulatoryVisitApiService.checkInSubject(payload),
    });

    const checkOutSubject = useMutation({
        mutationFn: (payload: any) =>
            ambulatoryVisitApiService.checkOutSubject(payload),
    });

    const insertSubjectActivityResult = useMutation({
        mutationFn: (payload: any) =>
            ambulatoryVisitApiService.insertSubjectActivityResult(payload),
    });

    const SelectdataAmbulatoryVisitActivityResult = useQuery({
        queryKey: ["selectdata-ambulatory-visit-activity-result", subjectassignmentid],
        queryFn: () => {
            return ambulatoryVisitApiService.selectdataAmbulatoryVisitActivityResult({
                visitsubjectassignmentid: Number(subjectassignmentid)
            });
        },
        enabled: !!subjectassignmentid,
    });


    return {
        SelectAllAmbulatoryVisit,
        SelectdataAmbulatoryVisit,
        assignSubjectsAmbulatoryVisit,
        SelectAllAssignedSubjects,
        insertAmbulatoryVisitStatusHistory,
        checkInSubject,
        checkOutSubject,
        insertSubjectActivityResult,
        SelectdataAmbulatoryVisitActivityResult,
    };
};
